import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  list(parameters={}) {
    return core.call({
      url: '/api/v1/alarm',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  detail(parameters={}) {
    return core.call({
      url: '/api/v1/alarm/detail',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  delete(parameters={}) {
    return core.call({
      url: '/api/v1/alarm/delete',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  allDelete(parameters={}) {
    return core.call({
      url: '/api/v1/alarm/allDelete',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  }
}
